export default () => ({
  entity: 'graduation',
  entities: 'graduations',
  currentEntity: {},
  graduations: [],
  errors: {
  },
  date: new Date(),
  configMonths: {
    format: 'YYYY',
    useCurrent: false,
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  },
  graduation: {
    attachment: {
      content: null,
      mime: null
    },
    label: 'Medicina',
    entity: null,
    year: null
  },
  // never use prefix v1.
  prefixRouter: 'professional.curriculum.graduations'
})



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/graduations/resources/data.js